import Immutable, { Map } from 'immutable';

import { ApiActions } from '../constants/ApiActions';
import {
  actions as SmartConversionActions,
  SmartConversionKeys,
} from '../constants/SmartConversion';
import { createReducer } from '../lib/ReducerUtils';

const INITIAL_STATE = Map({
  [SmartConversionKeys.TRACKING_EVENTS_KEY]: Map(),
  [SmartConversionKeys.IS_QUALIFIED_FOR_UPSELL_KEY]: false,
  [SmartConversionKeys.IS_SMART_CONVERSION_ENABLED_KEY]: false,
  [SmartConversionKeys.HAYMAKER_URL_KEY]: null,
});

// SKIPS REDUCER
export default createReducer(INITIAL_STATE, {
  [SmartConversionActions.SET_TRACKING_EVENTS]: setTrackingEvents,
  [ApiActions.GET_FRAGMENT_SUCCESS]: getFragmentSuccess,
  [ApiActions.REGISTER_SUCCESS]: loginOrRegistrationSuccess,
  [ApiActions.LOGIN_SUCCESS]: loginOrRegistrationSuccess,
  [ApiActions.DEVICE_LOGIN_SUCCESS]: loginOrRegistrationSuccess,
  [ApiActions.LOGOUT_SUCCESS]: logoutSuccess,
});

// CASE FUNCTIONS

function setTrackingEvents(state, action) {
  return state.set(
    SmartConversionKeys.TRACKING_EVENTS_KEY,
    Immutable.fromJS(action.data.trackingEvents),
  );
}

function getFragmentSuccess(state, action) {
  return state.set(
    SmartConversionKeys.IS_QUALIFIED_FOR_UPSELL_KEY,
    action.response.result.listenerQualifiesForUpsell,
  );
}

function loginOrRegistrationSuccess(state, action) {
  const listenerData = action.response.entities.listeners[action.response.result];
  return state.merge({
    [SmartConversionKeys.IS_SMART_CONVERSION_ENABLED_KEY]:
      listenerData.smartConversionDisabled !== undefined && !listenerData.smartConversionDisabled,
    [SmartConversionKeys.HAYMAKER_URL_KEY]: listenerData.smartConversionAdUrl,
  });
}

function logoutSuccess() {
  return INITIAL_STATE;
}
